import AuthenticationPage from 'pages/AuthenticationPage';
import MasterServicesPage from 'pages/MasterServicesPage';
import ServicesPage from 'pages/ServicesPage';

const routes = {
  public: [
    {
      path: '/callback',
      component: <AuthenticationPage />,
    },
  ],
  private: [
    {
      path: '/services',
      component: <ServicesPage />,
    },
    {
      path: '/masterServices',
      component: <MasterServicesPage />,
    },
  ],
};

export default routes;
